"use client";

import {
  createContext,
  type FC,
  type ReactNode,
  useContext,
  useState,
} from "react";

interface ServerParamsInterface {
  backendUrl: string;
  logged: boolean;
}

export const ServerParams = createContext({
  backendUrl: "",
  logged: false,
  // @ts-ignore
  setLogged: (value: boolean) => {},
} as ServerParamsInterface & { setLogged: (value: boolean) => void });

export const ServerParamsComponent: FC<{
  children: ReactNode;
  value: ServerParamsInterface;
}> = ({ children, value }) => {
  const [logged, setLogged] = useState(value.logged);
  return (
    <ServerParams.Provider value={{ ...value, logged, setLogged }}>
      {children}
    </ServerParams.Provider>
  );
};

export const useServerParams = () => {
  return useContext(ServerParams);
};
